// extracted by mini-css-extract-plugin
export default {"btnCreateTaskList":"ViewableTaskLists_btnCreateTaskList__qDcP5"};